<div class="container">
  <div class="content">
    <div class="center-column">
      <img class="nowaccount-logo" alt="NowAccount Logo" />
      <h1 [attr.aria-label]="this.headerText">{{ this.headerText }}</h1>
      <div class="button-wrapper">
        <app-primary-button
          text="{{ this.rememberYes }}"
          href=""
          [clickEvent]="this.RememberMeYes.bind(this)"
        >
        </app-primary-button>
      </div>
      <div class="button-wrapper">
        <app-primary-button
          text="{{ this.rememberNo }}"
          href=""
          [clickEvent]="this.RememberMeNo.bind(this)"
        >
        </app-primary-button>
      </div>
    </div>
  </div>
</div>
